import { Replacement } from 'roosterjs-editor-plugins';

function makeEmojiReplacement(sourceString: string, replacementHTML: string): Replacement {
    return {
        sourceString: sourceString,
        replacementHTML: replacementHTML,
        matchSourceCaseSensitive: true,
    };
}

// Used by CustomEdit, and only handles autocomplete for emoji shortcuts beginning
// with a non-colon
// Currently, EmojiPlugin and EmojiPickerPlugin handleEventExclusively when the
// inline emoji popup is shown (triggered by :), so they handle autocomplete for all
// emoji shortcuts beginning with a colon
const emojiReplacements: Replacement[] = [
    makeEmojiReplacement(';)', '😉'),
    makeEmojiReplacement(';P', '😜'),
    makeEmojiReplacement('<3', '❤️'),
    makeEmojiReplacement('</3', '💔'),
    makeEmojiReplacement(';*', '😘'),
    makeEmojiReplacement('B)', '😎'),
];

export default emojiReplacements;
